import { z } from 'zod';

export const FILE_PURPOSES = [
  'receipt',
  'pod',
  'signature',
  'vehicle_photo',
  'driver_photo',
  'document',
  'invoice_pdf',
  'invoice_upload',
  'logo',
  'avatar',
  'export',
] as const;
export type FilePurpose = (typeof FILE_PURPOSES)[number];

export const ALLOWED_MIME: Record<FilePurpose, readonly string[]> = {
  receipt: ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'],
  pod: ['image/jpeg', 'image/png', 'image/webp'],
  signature: ['image/png', 'image/webp'],
  vehicle_photo: ['image/jpeg', 'image/png', 'image/webp'],
  driver_photo: ['image/jpeg', 'image/png', 'image/webp'],
  document: ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'],
  invoice_pdf: ['application/pdf'],
  invoice_upload: ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'],
  logo: ['image/png', 'image/svg+xml', 'image/webp'],
  avatar: ['image/jpeg', 'image/png', 'image/webp'],
  export: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'],
};

export const MAX_FILE_BYTES = 15 * 1024 * 1024;

export const PresignUploadSchema = z.object({
  purpose: z.enum(FILE_PURPOSES),
  mime: z.string().min(3).max(100),
  sizeBytes: z.number().int().min(1).max(MAX_FILE_BYTES),
  fileName: z.string().max(200).optional(),
});
export type PresignUpload = z.infer<typeof PresignUploadSchema>;

export interface PresignUploadResponse {
  fileId: string;
  uploadUrl: string;
  method: 'PUT';
  headers: Record<string, string>;
  expiresInSec: number;
}

export const ConfirmUploadSchema = z.object({ fileId: z.string().uuid() });
